import axios from "axios"

const apiTest = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:3000",
  headers: { "Content-Type": "application/json" }
  // withCredentials: true
})

export default apiTest
